import {JobStatusConfiguration} from '../models/job.status/jobStatusConfiguration.model';
import {JobStatusSearchRequest} from '../models/job.status/jobStatusSearch.model';

export namespace JobStatuses {
  export class GetConfigurations {
    static readonly type = '[JobStatus api] Get Configurations';

    constructor(public force: boolean = false) {
    }
  }

  export class GetConfiguration {
    static readonly type = '[JobStatus api] Get Configuration';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class CreateConfiguration {
    static readonly type = '[JobStatus api] Create Configuration';

    constructor(public configuration: JobStatusConfiguration) {
    }
  }

  export class UpdateConfiguration {
    static readonly type = '[JobStatus api] Update Configuration';

    constructor(public configuration: JobStatusConfiguration) {
    }
  }

  export class DeleteConfiguration {
    static readonly type = '[JobStatus api] Delete Configuration';

    constructor(public configuration: JobStatusConfiguration) {
    }
  }

  export class ClearCurrentConfiguration {
    static readonly type = '[JobStatus api] Clear Current Configuration';
  }

  export class GetJobStatus {
    static readonly type = '[JobStatus api] Get Job Status';

    constructor(public jobId: string, public force: boolean = false) {
    }
  }

  export class UpdateJobStatus {
    static readonly type = '[JobStatus api] Update Job Status';

    constructor(public jobId: string, public statusId: string) {
    }
  }

  export class AddJobStatusComment {
    static readonly type = '[JobStatus api] Add Job Status Comment';

    constructor(public jobId: string, public comment: string) {
    }
  }

  /**
   * Saves the status change and the new comment together. Both write the same job status record,
   * so they are sent one after the other rather than in parallel.
   */
  export class SaveJobStatus {
    static readonly type = '[JobStatus api] Save Job Status';

    constructor(public jobId: string, public statusId: string, public statusChanged: boolean, public comment: string) {
    }
  }

  export class SearchJobStatuses {
    static readonly type = '[JobStatus api] Search Job Statuses';

    constructor(public request: JobStatusSearchRequest) {
    }
  }

  /**
   * The overview's quick search only filters the rows already loaded, so it never goes to the api;
   * it is kept in the store so coming back to the overview shows the same filter.
   */
  export class UpdateQuickSearch {
    static readonly type = '[JobStatus] Update Quick Search';

    constructor(public quickSearch: string) {
    }
  }
}
